<template>
      <v-card>
        <v-card-title> {{ $t('lottery_thai.head_result') }} </v-card-title>
        <v-card-actions>
          <v-row no-gutters class="d-flex align-center justify-end">
            <v-spacer />
            <span class="px-3">ค้นหา:</span>
            <div style="width: 150px">
              <v-text-field v-debounce:500ms="searchKeyword" v-model="search" outlined dense hide-details />
            </div>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :items="valueResult"
            :no-data-text="$t('not_found')" :no-results-text="$t('not_found')" :options.sync="pagination"
            :server-items-length="pagination.totalItems" :items-per-page="pagination.rowsPerPage"
            :page.sync="pagination.page" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :loading="loading" :search="search">
          </v-data-table>
        </v-card-actions>
      </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '@/store'
export default {
  props: {
    canCreate: {
      type: Boolean,
      require: true
    },
    roundDateNow: {
      type: String,
      require: true
    },
    dateFrom: {
      type: String,
      require: true
    },
    dateTo: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        {
          text: this.$t('lottery_thai.header_result1'),
          value: 'id',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
         text: this.$t('lottery_thai.header_result2'),
         value: 'roundDate',
         width: '100px',
         align: 'center',
         sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result3'),
          value: 'namePrize',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result4'),
          value: 'prize',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result5'),
          value: 'totalPrize',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result6'),
          value: 'phone',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result7'),
          value: 'lotteryNumber',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('lottery_thai.header_result8'),
          value: 'quantity',
          width: '100px',
          align: 'center',
          sortable: false,
        },
      ],
      valueResult: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
    }
  },
  async created() {
  },
  watch: {
    dateFrom: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (this.tab === 2 && newVal !== oldVal) {
          if(oldVal){
            this.loading = true
            this.pagination.page = 1
            await this.loadLimitData()
            this.loading = false
          }
        }
      }
    },
    dateTo: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (this.tab === 2 && newVal !== oldVal) {
          if(oldVal){
            this.loading = true
            this.pagination.page = 1
            await this.loadLimitData()
            this.loading = false
          }
        }
      }
    },
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont && this.tab === 2) {
          this.loading = true
          this.valueResult = []
          await this.getLotteryMemberResultData(newValue.page, newValue.itemsPerPage)
          this.loading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    async loadResultData() {
        this.valueResult = []
        await this.getLotteryMemberResultData(this.pagination.page, this.pagination.rowsPerPage)
    },
    async getLotteryMemberResultData(page, row, searchQuery = '') {

      this.valueResult = []
      try {
        let result = await this.$store.dispatch('lotteryThai/getLotteryMemberResult', `page=${page}&rows=${row}&from=${this.formatDateYYYY(this.dateFrom)}&to=${this.formatDateYYYY(this.dateTo)}${searchQuery}`)
        let resData = result.data
        for (let i = 0; i < resData.length; i++) {
          let disabledResult = true

          function isEmptyValues(...values) {
            for (const value of values) {
              if (value === null || value === '') {
                return true
              }
            }
            return false
          }

          this.valueResult.push({
            id: resData[i].id || null,
            roundDate: resData[i].roundDate || null,
            phone: resData[i].member.phone || null,
            lotteryNumber: resData[i].lotteryNumber || null,
            quantity: resData[i].quantity || null,
            namePrize: resData[i].namePrize || null,
            prize: resData[i].prize || null,
            multiplyTurnOver: resData[i].multiplyTurnOver || null,
            totalPrize: resData[i].totalPrize || null,
            totalTurnOver: resData[i].totalTurnOver || null,
            typeReward: resData[i].typeReward || null,
            disabledResult: disabledResult,
          })
        }

        this.pagination.totalItems = result.count
      } catch (e) { }
    },
    async searchKeyword(value) {
        this.loading = true
        this.pagination.page = 1
        if (value) {
            await this.getLotteryMemberResultData(1, this.pagination.rowsPerPage, `&phone=${value}`)
        } else {
            await this.getLotteryMemberResultData(1, this.pagination.rowsPerPage)
        }
        this.pagination.page = 1
        this.loading = false
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
  computed: {
    tab: {
        get() {
        return this.$store.state.lotteryThai.tab;
        },
        set(val) {
        this.$store.commit('lotteryThai/setActiveTab', val);
        }
    },
  },
}
</script>